export const getFrequencyCounterUrl = "/api/words/frequency/count";
export const baseFrequencyUrl = "/api/words/frequency";
export const aiUrl = "/api/ai/chat";